import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import { FeatureImage, FeatureImageType } from 'js/components/FeatureImage'
import { SharedSectionProps } from './types'

type Props = {
  title: string | null
  testimonials: {
    image: { responsiveImage: FeatureImageType } | null
    testimonial: string | null
    author: string | null
  }[]
} & SharedSectionProps

const Testimonials = ({ title, testimonials }: Props) => {
  return (
    <section className="lg:pt-66">
      <Container>
        <h2 className="quincy pb-32 pt-40 text-32 leading-37 lg:pb-48 lg:pt-0 lg:text-48 lg:leading-52">
          {title}
        </h2>
        <div className="grid auto-rows-auto gap-x-[40px] md:grid-cols-2 md:grid-rows-1">
          {testimonials.map((testimonial) => (
            <div key={testimonial.author} className="relative order-1 md:pb-0">
              <div className="mx-auto lg:h-[350px] lg:w-[333px]">
                <FeatureImage
                  image={
                    testimonial?.image?.responsiveImage as FeatureImageType
                  }
                  className=" w-full rounded-b-none rounded-t-16 md:w-auto md:rounded-8"
                />
              </div>
              <div className="rounded-b-16 bg-white px-16 pb-24 shadow-greyShadow md:bg-transparent md:px-0 md:pb-0 md:shadow-none">
                <p className="pt-24 text-17 font-semiregular leading-21 md:pt-32 md:text-20 md:leading-27">
                  {testimonial.testimonial}
                </p>
                <p className="pt-16 text-17 font-semiregular leading-21 md:text-20 md:leading-27">
                  — {testimonial.author}
                </p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default Testimonials
